<template>
    <div class="view view--event-create">
        <div class="has-margin-b30">
            <control
                name="titleControl"
                type="text"
                v-bind:label="__('Title')"
                v-model="event.title"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.title != null"
            >
                {{ errors.title[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="tags[]"
                type="tag"
                icon="search"
                label-field="title"
                placeholder="start typing the title of the tag here"
                v-bind:source-search="getTags"
                v-bind:label="__('Tags')"
                v-model="event.tags"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.tags != null"
            >
                {{ errors.tags[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="shortDescriptionControl"
                type="textarea"
                v-bind:label="__('Short description')"
                v-model="event.shortDescription"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.short_description != null"
            >
                {{ errors.short_description[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="descriptionControl"
                type="textarea"
                v-bind:label="__('Description')"
                v-model="event.description"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.description != null"
            >
                {{ errors.description[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="startAtControl"
                type="date"
                v-bind:label="__('Start At')"
                v-model="event.startAt"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.start_at != null"
            >
                {{ errors.start_at[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="featuredVideoControl"
                type="file"
                ref="videoControl"
                v-bind:filename="event.videoUrl"
                v-bind:label="__('Featured video')"
                v-model="event.videoFile"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.featuredVideo != null"
            >
                {{ errors.featuredVideo[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="featuredImageControl"
                type="file"
                ref="imageControl"
                v-bind:filename="event.imageUrl"
                v-bind:label="__('Featured image')"
                v-model="event.imageFile"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.featuredImage != null"
            >
                {{ errors.featuredImage[0] }}
            </div>
        </div>

        <btn
            class="is-success"
            type="default"
            v-html="__('Create')"
            v-on:click="createEvent"
        ></btn>
    </div>
</template>

<script>
import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import router from '../../router';
import TagRepository from '../../repositories/TagRepository';
import EventRepository from '../../repositories/EventRepository';
import store from '../../store';
import MessageHandler from '../../messageHandler';

export default {
    components: {
        Btn,
        Control
    },
    data: function() {
        return {
            dateConfig: {
                enableTime: false
            },
            errors: {},
            event: {
                id: null,
                createdAt: null,
                deletedAt: null,
                description: '',
                imageFile: null,
                imageUrl: null,
                shortDescription: '',
                startAt: null,
                tags: [],
                title: '',
                userId: null,
                updatedAt: null,
                videoFile: null,
                videoUrl: null
            },
            eventRepository: new EventRepository(),
            tagRepository: new TagRepository()
        };
    },
    methods: {
        createEvent: async function() {
            try {
                const data = {
                    description: this.event.description,
                    image: this.event.imageFile,
                    imageName: this.$refs.imageControl.selectedFilename,
                    tags: this.event.tags.map(tag => tag.title),
                    title: this.event.title,
                    short_description: this.event.shortDescription,
                    start_at: this.event.startAt,
                    video: this.event.videoFile,
                    videoName: this.$refs.videoControl.selectedFilename
                };

                await this.eventRepository.createEvent(data);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Event was successfully created.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await router.push({
                    path: '/events'
                });
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        getTags: async function(search) {
            try {
                const tags = await this.tagRepository.getTags(search);

                if (tags.length === 0) {
                    return [
                        {
                            title: search,
                            id: 0
                        }
                    ];
                }

                return tags;
            } catch (error) {
                return [];
            }
        }
    }
};
</script>
